/**
 * Logging utility using tslog for browser environment
 */

import { Logger } from 'tslog';

const NODE_ENV = import.meta.env.MODE || 'development';
const LOG_LEVEL = import.meta.env.VITE_LOG_LEVEL || 'info';

// Map log levels
const getMinLevel = () => {
  switch (LOG_LEVEL.toLowerCase()) {
    case 'error': return 4;
    case 'warn': return 3;
    case 'info': return 2;
    case 'debug': return 1;
    case 'trace': return 0;
    default: return 2;
  }
};

// Create main logger for browser
export const logger = new Logger({
  name: 'web-ui',
  type: NODE_ENV === 'production' ? 'json' : 'pretty',
  minLevel: getMinLevel(),
  hideLogPositionForProduction: NODE_ENV === 'production',
  prettyLogTemplate: '{{yyyy}}.{{mm}}.{{dd}} {{hh}}:{{MM}}:{{ss}}:{{ms}}\t{{logLevelName}}\t[{{name}}]\t',
  prettyErrorTemplate: '\n{{errorName}} {{errorMessage}}\nerror stack:\n{{errorStack}}',
  prettyLogStyles: {
    logLevelName: {
      '*': ['bold', 'black', 'bgWhiteBright', 'dim'],
      SILLY: ['bold', 'white'],
      TRACE: ['bold', 'whiteBright'],
      DEBUG: ['bold', 'green'],
      INFO: ['bold', 'blue'],
      WARN: ['bold', 'yellow'],
      ERROR: ['bold', 'red'],
      FATAL: ['bold', 'redBright'],
    },
    dateIsoStr: 'white',
    filePathWithLine: 'white',
    name: ['white', 'bold'],
    nameWithDelimiterPrefix: ['white', 'bold'],
    nameWithDelimiterSuffix: ['white', 'bold'],
    errorName: ['bold', 'bgRedBright', 'whiteBright'],
    fileName: ['yellow'],
  },
});

// Create child logger for specific modules
export function createModuleLogger(module: string) {
  return logger.getSubLogger({ name: module });
}

// Export default logger
export default logger;